import FragmentSerializer from 'client-portal/serializers/-fragment';

export default class ContactInfoContact extends FragmentSerializer {
  serialize(snapshot, options) {
    const record = snapshot.record;

    if (record.isMarkedForDeletion) {
      return {
        'relationship_id': record.relationshipId,
        _destroy: true,
      };
    }

    return super.serialize(snapshot, options);
  }
}
